import React, { useEffect, useState } from 'react';
import { UpOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const ScrollToTopButton: React.FC = () => {
    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        setVisible(window.scrollY > 300);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisible);
        return () => {
            window.removeEventListener('scroll', toggleVisible);
        };
    }, []);

    if (!visible) return null;

    return (
        <Button
            onClick={scrollToTop}
            aria-label="Scroll to top"
            shape="circle"
            type="primary"
            icon={<UpOutlined style={{ fontSize: '1.25rem' }} />}
            style={{
                position: 'fixed',
                bottom: '1.5rem',
                right: '1.5rem',
                zIndex: 1000,
                padding: '20px',
                backgroundColor: 'rgba(111, 188, 255, 0.8)',
                color: '#fff',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
            }}

            onMouseOver={(e) => {
                (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.1)';
            }}
            onMouseOut={(e) => {
                (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
            }}
        />
    );
};

export default ScrollToTopButton;
